'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

/**
 * ScrollToTop Component
 * Ensures all page navigations start at the top
 * Uses multiple methods for instant, flicker-free scroll restoration
 */
export function ScrollToTop() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Method 1: Immediate scroll (synchronous)
    // This prevents any visual jump by executing before paint
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Method 2: Backup scroll after slight delay (for edge cases)
    // Some browsers may restore scroll after initial load
    const timeoutId = setTimeout(() => {
      if (window.scrollY !== 0) {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname, searchParams]);

  // Method 3: Prevent scroll restoration on mount
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  return null;
}
